import styled from "styled-components";
import BackHeader from "../shared/components/BackHeader";
import {gray300, gray900} from '../shared/themes/color';
import {useState} from "react";

const MainContainer = styled.div`
  margin: auto;
`;

const ItemContact = styled.p`
  display: flex;
  margin-bottom: 1.5rem;
  align-items: center;
  
  i {
    font-size: 2rem;
  }

  i:first-of-type {
    margin-right: .75rem;
    color: ${gray900};
  }

  i:last-of-type {
    display: none;
    margin-left: .5rem;
    font-size: 1.25rem;
    opacity: 1;
    cursor: pointer;
    transition: all 200ms ease-in-out;
    color: ${props => props.check ? gray900 : gray300};
    
    :hover {
      color: ${gray900};
    }
  }
`;

export const ContactItem = ({data, icon, props}) => {

  const [check, setCheck] = useState(false);

  return (
    <ItemContact>
      <i className='material-icons'>{icon || 'remove'}</i>
      {data || 'Data contact'}
      <i className='material-icons'
         onClick={() => setCheck(true)}>{check ? 'done' : 'content_copy'}
      </i>
    </ItemContact>
  );
};

const Contact = () => {

  return (
    <MainContainer>
      <BackHeader/>
      <h1>Contacto</h1>
      <div>
        <ContactItem icon="phone_iphone" data='(443) 357 2909'/>
        <ContactItem icon="inbox" data='jonminimal@gmail.com'/>
      </div>
    </MainContainer>
  );
};

export default Contact;
